import { CharField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Biblioteca } from "../../types"

export default function BibliotecaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Biblioteca>()
  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <CharField
        label="Città"
        layout="horizontal"
        value={values.citta}
        onChange={(value) => {
          setFieldValue("citta", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "citta") : undefined}
        errorMessage={getIn(errors, "citta")}
        required
      />
    </Col>
  )
}
